export enum LuigisBoxClickEventTypeEnum {
    Click = 'click',
    Conversion = 'buy',
}

export type LuigisBoxClickEventType = 'click' | 'add-to-cart' | 'add-to-wishlist' | 'buy'
